<template>
    <b-row align-h="center">
        <b-col cols="12" sm="10" md="8">
            <div class="mb-2">
                <div class="discrete-slider__slider-numbers d-flex justify-content-between">
                    <div v-for="(option, i) in options" :key="i">
                        <div 
                            v-if="(option.value === activeStep) || (activeStep === null && option.value === range[0])"
                            class="discrete-slider__slider-number"
                        >
                            {{ option.text }}
                        </div>
                    </div>
                </div>
                <div class="discrete-slider__slider">
                    <slider
                        :range="range"
                        :stepped="true"
                        @change="handleChange"
                        :labelMin="labelMin"
                        :labelMax="labelMax"
                    />
                </div>
            </div>
        </b-col>
    </b-row>
</template>
<script>
import slider from '@/components/inputs/slider'

export default {
    name: 'discreteSlider',
    components: {
        slider,
    },
    props: {
        options: {
            type: Array,
            default: () => []
        },
        range: {
            type: Array,
            default: [1, 10]
        },
        labelMin: {
            type: String,
        },
        labelMax: {
            type: String,
        }
    },
    data() {
        return {
            activeStep: null
        }
    },
    methods: {
        handleChange(num) {
            this.activeStep = num
            const selectedOption = this.options.find(option => option.value === num)
            this.$emit('change', selectedOption)
        }
    }
}
</script>
<style lang="scss">
  .discrete-slider__slider-number {
    font-size: 2.25em;
    color: $main-font-grey;
  }

  .discrete-slider__slider {
    margin: 0 10px;
  }

  .discrete-slider__label {
    font-size: 0.875rem;
    width: 80px;
  }

</style>